module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Normally we would have a long list of acknowledgements, but this will be short due to researching this book during a pandemic that limited our access to people and places. We hope that despite this major obstacle we have written a book that leads Omahans to explore and better understand their city.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("We thank:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Former city planning director Martin “Marty” Shukert for explaining how the city developed and for helping us select the most important buildings to feature. However, any mistakes or misjudgments are ours, not Marty’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Local history librarians Martha Grenzeback and Lynn Sullivan of the Omaha Public Library, without whose help no one could write any book about local history.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Great Plains Black History Museum director Eric Ewing for his assistance with the North Omaha chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("History Nebraska for its website with detailed information about state historical markers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Omaha Public Library for its outstanding online local history resources, including photos, and to the Omaha Public Library Foundation that has helped fund their acquisition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Boys Town and the Nebraska Jewish Historical Society for their assistance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The authors of books on Omaha history cited in our bibliography.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1789404b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 72
// module chunks = 0